// Centralized add-on definitions and helpers.
// Reused by Landing/Apply/HeroApplicationCard/AdminOrderDetail and Wizard.

import { Briefcase, Users, Home } from "lucide-react";

export const ADD_ONS = [
  {
    id: "noc",
    name: "No Objection Certificate",
    short: "NOC",
    icon: Briefcase,
    price: 19,
    description: "Employer letter confirming employment and granting travel permission",
    // Preview tile metadata (matches PreviewCard rule `noc` / `no objection`)
    preview: {
      title: "No Objection Certificate",
      package_contents: "Employer authorization letter",
    },
  },
  {
    id: "sponsor_letter",
    name: "Sponsor Letter",
    short: "Sponsor Letter",
    icon: Users,
    price: 19,
    description: "Formal letter from your financial sponsor covering travel and living costs",
    preview: {
      title: "Sponsor Letter",
      package_contents: "Financial guarantee letter",
    },
  },
  {
    id: "invitation_letter",
    name: "Invitation Letter",
    short: "Invitation Letter",
    icon: Home,
    price: 19,
    description: "Letter from your host in the Schengen area inviting you to visit",
    preview: {
      title: "Invitation Letter",
      package_contents: "Host invitation letter",
    },
  },
];

export const ADD_ONS_BY_ID = Object.fromEntries(ADD_ONS.map((a) => [a.id, a]));

export function addOnPrice(ids = []) {
  return (ids || []).reduce((sum, id) => sum + (ADD_ONS_BY_ID[id]?.price || 0), 0);
}

export function labelForItems(items = [], addOnsSelected = []) {
  const baseCount = (items || []).filter((it) => !/whatsapp|24\/?7|support/i.test(it?.title || "")).length;
  const hasSupport = (items || []).some((it) => /whatsapp|24\/?7|support/i.test(it?.title || ""));
  const support = hasSupport ? "24/7 WhatsApp Support" : null;

  const addCount = (addOnsSelected || []).length;
  if (addCount === 0) {
    if (support) return `${baseCount} documents + ${support}`;
    return `${baseCount} documents included`;
  }
  const addPart = `${addCount} ${addCount === 1 ? "add-on" : "add-ons"}`;
  if (support) return `${baseCount} documents + ${addPart} + ${support}`;
  return `${baseCount} documents + ${addPart}`;
}

// Empty schema for the per-order add_on_details object.
export function emptyAddOnDetails() {
  return {
    noc: { job_title: "", employment_start_date: "", signatory_name: "", signatory_title: "",
           employer_name: "", employer_address: "", employer_phone: "" },
    sponsor_letter: { sponsor_name: "", relationship: "", occupation: "", address: "", phone: "", email: "" },
    invitation_letter: { host_name: "", host_address: "", host_phone: "", host_email: "",
                         relationship: "", residency_status: "", purpose: "" },
  };
}

// Per-add-on required field keys for validation in the wizard.
export const ADDON_REQUIRED = {
  noc: ["job_title", "employment_start_date", "signatory_name", "signatory_title",
        "employer_name", "employer_address", "employer_phone"],
  sponsor_letter: ["sponsor_name", "relationship", "occupation", "address", "phone"],
  invitation_letter: ["host_name", "host_address", "host_phone", "relationship", "residency_status", "purpose"],
};

export function addOnsAreComplete(selectedIds = [], details = {}) {
  for (const id of selectedIds || []) {
    const required = ADDON_REQUIRED[id] || [];
    const data = details?.[id] || {};
    for (const k of required) if (!data[k]) return false;
  }
  return true;
}

export function addOnMissingFields(id, details = {}) {
  const required = ADDON_REQUIRED[id] || [];
  const data = details?.[id] || {};
  return required.filter((k) => !data[k]);
}
